/**
 * context/consoleIdentity.ts
 * Who the console says is signed in, and to which workspace — from the real
 * session (GET /v1/me), never from data/platformSeed.
 *
 * The console's working state starts as a copy of the demo seed. Its user and
 * org were never replaced, so a real customer opening the platform home read
 * "Welcome back, Anjali" under an "Acme Retail" switcher, and any org showed
 * as its first word + " Retail" (dev, 28 Oct 2026). Until /me answers these
 * read as empty — a blank beats someone else's name.
 */

export interface ConsoleIdentity {
  userName: string;
  userEmail: string;
  orgName: string;
}

export function consoleIdentity(session: {
  fullName?: string | null;
  user?: { email?: string | null } | null;
  org?: { name?: string | null } | null;
}): ConsoleIdentity {
  const userEmail = (session.user?.email ?? '').trim();
  return {
    userName: (session.fullName ?? '').trim() || userEmail,
    userEmail,
    orgName: (session.org?.name ?? '').trim(),
  };
}

/** "Welcome back, Gokul" — or just "Welcome back" before the name is known. */
export function welcomeTitle(userName: string): string {
  const first = userName.trim().split(/\s+/)[0];
  return first ? `Welcome back, ${first}` : 'Welcome back';
}

/** The letter on the workspace badge: the org's first letter, else a dot. */
export function orgInitial(orgName: string): string {
  const ch = orgName.trim().charAt(0);
  return ch ? ch.toUpperCase() : '·';
}
